import { Link } from "react-router-dom";
import type { Video } from "@/mocks/videos";

interface EmptyStateProps {
  title: string;
  description: string;
  onReset?: () => void;
  recommendations?: Video[];
}

export default function EmptyState({ title, description, onReset, recommendations }: EmptyStateProps) {
  return (
    <div className="rounded-lg border border-background-800 bg-background-900 p-8 text-center md:p-12">
      <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-background-800 text-secondary-400">
        <i className="ri-inbox-2-line text-3xl" />
      </span>
      <h3 className="mt-5 font-heading text-lg font-bold text-foreground-50">{title}</h3>
      <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-foreground-400">{description}</p>
      {onReset && (
        <button
          type="button"
          onClick={onReset}
          className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-950 transition-colors hover:bg-accent-600 cursor-pointer"
        >
          <i className="ri-refresh-line text-base" />
          重置筛选条件
        </button>
      )}

      {recommendations && recommendations.length > 0 && (
        <div className="mt-10 border-t border-background-800 pt-8 text-left">
          <h4 className="font-heading text-base font-semibold text-foreground-100">
            <a href="#recommend" className="cursor-pointer hover:text-accent-400">
              你可能还喜欢
            </a>
          </h4>
          <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4 md:gap-4">
            {recommendations.slice(0, 4).map((video) => (
              <Link
                key={video.id}
                to={`/detail/${video.id}`}
                className="group overflow-hidden rounded-md border border-background-800 bg-background-950 transition-colors hover:border-accent-500/70 cursor-pointer"
              >
                <div className="aspect-[2/3] w-full overflow-hidden">
                  <img
                    src={video.cover}
                    alt={`${video.title} - 多多视频推荐`}
                    title={`${video.title} - 多多视频`}
                    className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-2.5">
                  <p className="line-clamp-1 text-xs font-medium text-foreground-100 group-hover:text-accent-400">
                    {video.title}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}